import React, { useEffect, useState } from "react";
import { getMerchant } from '../../helpers/ReduxHelpers';
import { apiConstants, getGeneric, postGeneric } from '../../common/constants';
import { useForm } from "react-hook-form";
import { Alert, Box, Button, FormControlLabel, Grid, Switch, Tooltip, Typography } from "@mui/material";
import { FormProvider, RHFTextField } from "../../common/hook-form";
import { LoadingButton } from "@mui/lab";
import { primaryBtnSx, secondaryBtnSx, filterBarSx } from '../../styles/patterns';
import { FONT, SIZE, WEIGHT } from '../../styles/foundation/typography';
import { NAVY, SUBTLE } from '../../styles/foundation/colors';
import { primaryTextSx, cellStackSx } from '../orders/list2/cellStyles';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup'
import Loader from "../../common/Loader"
import { useSnackbar } from "notistack";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import ConfirmDialog from "../../common/ConfirmDialog";


const RTORvpEmailConfig = () => {
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''
    const [isLoading, setLoading] = useState(false);
    const [rtoRvpConfig, setRTORvpConfig] = useState(null);
    const [isRTORvpEnabled, setRTORvpEnabled] = useState(false);
    const [reload, setReload] = useState(0);
    const { enqueueSnackbar } = useSnackbar();
    const [deleteData, setDeleteData] = useState();
    const [dialogConfig, setDialogConfig] = useState({
        open: false,
        type: '', // 'delete' or 'switch'
        title: '',
        message: '',
        disableButtons: false,
        onConfirm: () => { },
        onReject: () => { }
    });
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(0);


    const columns = [
        {
            field: 'emails',
            headerAlign: "left",
            hideSortIcons: true,
            headerName: 'Emails',
            flex: 1.2,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}><Typography sx={primaryTextSx}>{row?.email}</Typography></Box>
                )
            },
        },
        {
            field: 'action',
            headerAlign: "left",
            hideSortIcons: true,
            headerName: 'Action',
            flex: 0.5,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Button
                        onClick={() => handleCancelOrder(row)}
                        disabled={!isRTORvpEnabled}
                        color="error"
                        variant="outlined"
                        size="small"
                    >
                        Delete
                    </Button>
                );
            },
        },
    ];

    const emailListRegExp = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,}\s*,\s*)*[\w+-.%]+@[\w-.]+\.[A-Za-z]{2,}$/

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                email: Yup.string()
                    .matches(emailListRegExp, { message: 'Invalid email format', excludeEmptyString: true })
                    .required("Email is required!"),
            })
        ),
        defaultValues: {
            email: '',
            // rvpEmailDateRange: '',
        }
    })
    const { handleSubmit: handleSubmitForm, reset } = methods


    const postMerchantConfig = (payload) => {
        postGeneric(`${apiConstants.UPDATE_REPORT_CONFIG}`, payload).then(response => {
            enqueueSnackbar('Success', { variant: 'success' })
            reset()
            setReload(reload => reload + 1)
            setLoading(false)
        })
            .catch((err) => {
                enqueueSnackbar(err?.response?.data?.message || 'Some error occurred', { variant: 'error' })
                console.error(err)
                setLoading(false)
            })
    }

    const onSubmit = (data) => {
        setLoading(true);
        const existingEmails = rtoRvpConfig?.rvpRtoOfdB2CReceivedByEmails || [];
        const emailsArray = data.email.split(',').map(email => email.trim());
        const payload = {
            "merchantOId": merchantId,
            "rvpRtoOfdB2CReceivedByEmails": [
                ...existingEmails, ...emailsArray
            ],
            "rvpRtoOfdB2CCCEmails": ["ProshipTechTeam@prozo.com"],
            "isRvpRtoOfdB2CEnabled": true,
            // "rvpEmailDateRange": data.rvpEmailDateRange
        }

        if (rtoRvpConfig) {
            postMerchantConfig(payload)
        } else {
            postNPRConfigAdd(payload)
        }
        // postMerchantConfig(payload)
    }

    const postNPRConfigAdd = (payload) => {
        postGeneric(`${apiConstants.ADD_NDR_EMAIL_CONFIG}`, payload).then(response => {
            enqueueSnackbar('Success', { variant: 'success' })
            reset()
            setReload(reload => reload + 1)
            setLoading(false)
        })
            .catch((err) => {
                console.error(err)
                enqueueSnackbar('Some error occurred', { variant: 'error' })
                setLoading(false)
            })
    }

    const handleCancelOrder = (data) => {
        setDeleteData(data);
        setDialogConfig({
            open: true,
            type: 'delete',
            title: '',
            message: rtoRvpConfig?.rvpRtoOfdB2CReceivedByEmails?.length === 1
                ? "Please disable via Toggle Switch"
                : "Are you sure you want to delete ?",
            disableButtons: rtoRvpConfig?.rvpRtoOfdB2CReceivedByEmails?.length === 1,
            onConfirm: handleDelete,
            onReject: () => setRTORvpEnabled(rtoRvpConfig?.isRvpRtoOfdB2CEnabled)
        });
    }

    const handleDelete = () => {
        const filteredEmails = rtoRvpConfig?.rvpRtoOfdB2CReceivedByEmails.filter(email => email !== deleteData.email);
        const payload = {
            "merchantOId": merchantId,
            "rvpRtoOfdB2CReceivedByEmails": filteredEmails,
        }
        postMerchantConfig(payload)
    }

    useEffect(() => {
        setLoading(true)
        getGeneric(`${apiConstants.GET_REPORT_CONFIG}?merchantOId=${merchantId}`).then((res) => {
            setRTORvpConfig(res.data);
            setRTORvpEnabled(res.data.isRvpRtoOfdB2CEnabled);
            setLoading(false)
        }).catch((err) => {
            console.log(err)
            setLoading(false)
        })
    }, [merchantId, reload])

    const toggleEmailConfig = () => {
        const payload = {
            "merchantOId": merchantId,
            "isRvpRtoOfdB2CEnabled": !isRTORvpEnabled,
        }
        postMerchantConfig(payload)
    }

    const handleSwitchConfirmation = (e) => {
        setDialogConfig({
            open: true,
            type: 'switch',
            title: '',
            message: "Are you sure you want to change the email configuration?",
            disableButtons: false,
            onConfirm: handleSwitchAction,
            onReject: () => { }
        });
    };

    const handleSwitchAction = () => {
        toggleEmailConfig()
    };

    return (
        <>
            {(isLoading) && <Loader />}
            <ConfirmDialog
                title={dialogConfig.title}
                open={dialogConfig.open}
                setOpen={(open) => setDialogConfig(prev => ({ ...prev, open }))}
                disableButtons={dialogConfig.disableButtons}
                onReject={dialogConfig.onReject}
                onConfirm={dialogConfig.onConfirm}
            >
                {dialogConfig.message}
            </ConfirmDialog>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <FormProvider methods={methods} onSubmit={handleSubmitForm(onSubmit)}>
                        <Box sx={filterBarSx}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                                <Box>
                                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.md, fontWeight: WEIGHT.semibold, color: NAVY }}>RTO/RVP Email Notification Settings</Typography>
                                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: SUBTLE, mt: 0.5 }}>Manage email notifications for RTO and RVP orders</Typography>
                                </Box>
                                <Tooltip title={isRTORvpEnabled ? "Disable Emails" : "Enable Emails"}>
                                    <FormControlLabel
                                        control={<Switch checked={isRTORvpEnabled} onChange={(e) => handleSwitchConfirmation(e)} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' } }} />}
                                        label={<Typography sx={{ fontFamily: FONT, fontSize: SIZE.xs, color: isRTORvpEnabled ? '#4caf50' : SUBTLE }}>{isRTORvpEnabled ? 'Enabled' : 'Disabled'}</Typography>}
                                        labelPlacement="start"
                                    />
                                </Tooltip>
                            </Box>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <RHFTextField
                                        name="email"
                                        label="Add Emails *"
                                        size="small"
                                    />
                                </Grid>
                                {/* <Grid item xs={12} md={3}>
                                    <RHFTextField
                                        name="rvpEmailDateRange"
                                        label="Email Date Range"
                                        size="small"
                                        type="number"
                                    />
                                </Grid> */}
                                <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <LoadingButton loading={isLoading}
                                        type="submit"
                                        variant="contained"
                                        size="small"
                                        sx={primaryBtnSx}
                                    >Add</LoadingButton>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        sx={{ ml: 1, ...secondaryBtnSx }}
                                        onClick={() => {
                                            reset();
                                        }}
                                    >Reset</Button>
                                </Grid>
                            </Grid>
                            <Alert severity="info" sx={{ mt: 2, fontFamily: FONT, fontSize: SIZE.xs }}>
                                This email will be sent daily at 1 PM after courier partners update return out-for-delivery status
                            </Alert>
                        </Box>
                    </FormProvider>
                    <Grid item xs={12} sx={{ mt: 1 }}>
                        <ProzoDataGrid
                            columns={columns}
                            autoHeight={true}
                            rows={(rtoRvpConfig?.rvpRtoOfdB2CReceivedByEmails?.length > 0)
                                ? rtoRvpConfig?.rvpRtoOfdB2CReceivedByEmails.map((email, index) => ({ id: index, email }))
                                : []
                            }
                            sizePerPage={sizePerPage}
                            setSizePerPage={setSizePerPage}
                            setPage={setPage}
                            page={page}
                            paginationMode='client'
                            pagination={true}
                            rowCount={rtoRvpConfig?.rvpRtoOfdB2CReceivedByEmails?.length || 0}
                            // hideCountNumber={true}
                            getRowId={(row) => row.id}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default RTORvpEmailConfig;
